import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useAdfoxContext } from 'shared/context/AdfoxContext';
import { useBannerEnrichments } from 'shared/hooks/useBannerEnrichments';
import { addressSelector } from 'shared/selectors';

import { TgbNativedescGeneralNarrow } from './components/TgbNativedescGeneralNarrow';
import { TgbNativedescGeneralWide } from './components/TgbNativedescGeneralWide';
import { getTgbNativedescGeneralNarrowProps } from './utils/getTgbNativedescGeneralNarrowProps';
import { getTgbNativedescGeneralWideProps } from './utils/getTgbNativedescGeneralWideProps';

type TTgbNativedescGeneralContainerProps = {
  behavior: 'wide' | 'narrow';
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: React.FC<TTgbNativedescGeneralContainerProps> = ({ context, behavior }) => {
  const { sizes } = useAdfoxContext();

  const address = useSelector(addressSelector);

  const bannerEnrichment = useBannerEnrichments(context);

  switch (behavior) {
    case 'narrow':
      return (
        <TgbNativedescGeneralNarrow {...getTgbNativedescGeneralNarrowProps({ context, bannerEnrichment, sizes })} />
      );
    case 'wide': {
      return (
        <TgbNativedescGeneralWide
          {...getTgbNativedescGeneralWideProps({ address, context, bannerEnrichment, sizes })}
        />
      );
    }
  }
};
